import "./scss/style.scss";
import React, { useEffect, useMemo, useState } from "react";
import HeaderComp from "./component/HeaderComp";
import { Route, Routes, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import Player from "./Player";
import Home from "./Home";
import FooterComp from "./component/FooterComp";
import { setLanguage } from "./store/languageSlice";
import { fetchCustomizeData } from "./store/customizeSlice";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const App = () => {
  const dispatch = useDispatch();
  const query = useQuery();
  const lang = useMemo(() => query.get("lang"), [query]);
  const [videoInfo, setVideoInfo] = useState([]);

  let isFetch = true;
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${window.location.origin}/video-material/data.json`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        const jsonData = await response.json();
        setVideoInfo(jsonData);
      } catch (error) {
        console.error("Error fetching JSON data:", error);
      }

      if (lang) {
        dispatch(setLanguage(lang));
      }
      dispatch(fetchCustomizeData());
    };
    if (isFetch) {
      fetchData().then(r => {});
      isFetch = false;
    }
  }, []);
  return (
    <div className="learnRobo">
      <HeaderComp />
      <Routes>
        <Route index path={`/`} element={<Home videoInfo={videoInfo} />} />
        <Route
          path={`/watch/:videoId`}
          element={<Player videoInfo={videoInfo} />}
        />
        <Route path="*" element={<Home videoInfo={videoInfo} />} />
      </Routes>
      <FooterComp />
    </div>
  );
};

export default App;
